import { render, staticRenderFns } from "./comentarios.vue?vue&type=template&id=390c75a7&"
import script from "./comentarios.vue?vue&type=script&lang=js&"
export * from "./comentarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports